import { OperatorAccess, PermissionRequirement, can } from './permissions';

/**
 * Privilegios numéricos del SC que algunas pantallas usaban antes de los
 * roles v8. Espejo de `PRIVILEGE` en sporttia-service.
 */
export const LEGACY_PRIVILEGES = {
    DELETE_PAYMENT: 28,
    MANAGE_DEVICES: 29,
} as const;

/** `OperatorAccess` más los privilegios numéricos del SC (`cxt.privileges`). */
export type OperatorAccessWithPrivileges = OperatorAccess & {
    privileges?: readonly number[] | null;
};

/**
 * Para los puntos que antes dependían de un privilegio numérico: con los roles
 * encendidos exige el permiso v8; con los roles apagados, el privilegio de
 * siempre, para que el gestor se comporte exactamente como antes.
 */
export function canOrHasPrivilege(
    access: OperatorAccessWithPrivileges,
    required: PermissionRequirement,
    privilegeId: number,
): boolean {
    if (access.rolesEnabled) return can(access, required);

    return !!access.privileges?.includes(privilegeId);
}
